import {useAccount, useIsAuthenticated, useMsal} from '@azure/msal-react'
import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import * as auth from '../redux/AuthRedux'

const MsalService = () => {
  const isAuthenticated = useIsAuthenticated()
  const {instance, accounts} = useMsal()
  const account = useAccount(accounts[0] || {})
  const dispatch = useDispatch()

  const setActiveAccount = () => {
    if (instance.getActiveAccount() == null) {
      const allAccounts = instance.getAllAccounts()
      if (allAccounts.length > 0) {
        instance.setActiveAccount(allAccounts[0])
      }
    }
  }

  const acquireTokenSilent = useCallback(
    async (scopes: string[]) => {
      if (!account) {
        return undefined
      }

      try {
        const response = await instance.acquireTokenSilent({
          scopes,
          account,
        })
        return response?.accessToken
      } catch (error) {
        console.error('Error getting token:', error)
        return undefined
      }
    },
    [instance, account]
  )

  const logoutAzureAccount = () => {
    const logoutAccount = instance.getActiveAccount() ?? account ?? accounts[0]
    dispatch(auth.actions.logout())

    const logoutRequest = logoutAccount ? {account: logoutAccount} : undefined
    const logoutPromise = logoutRequest ? instance.logoutPopup(logoutRequest) : instance.logoutPopup()

    logoutPromise.catch((error) => {
      console.error(error)
    })
  }

  return {acquireTokenSilent, logoutAzureAccount, setActiveAccount, isAuthenticated, accounts}
}

export default MsalService
